/**
 * Bridge 就绪探测与 hasBridge 判定（对齐 domi-ai-home native-image-picker）。
 * Home 二级 / 外嵌 iframe 内通常无注入对象，靠 UA / 顶层标记判定，实际调用走顶层转发。
 */

import {
  isTopBridgeMarkedAvailable,
  shouldRelayBridgeToTop,
} from './bridge-relay';
import {
  hasJavascriptBridge,
  isDomiKidsNativeWebView,
  isNativeAppContainer,
} from './native-env';

export type JavascriptBridge = {
  registerHandler: (event: string, cb: (payload: unknown) => void) => void;
  callHandler: (action: string, params: unknown) => void;
};

export function hasBridge(): boolean {
  if (typeof window === 'undefined') return false;
  if (shouldRelayBridgeToTop()) {
    return (
      isDomiKidsNativeWebView() || isTopBridgeMarkedAvailable() || hasJavascriptBridge()
    );
  }
  return isNativeAppContainer() && hasJavascriptBridge();
}

/** 等待 Bridge 注入；超时返回 null */
export async function waitForJavascriptBridge(timeoutMs = 5_000): Promise<JavascriptBridge | null> {
  if (typeof window === 'undefined') return null;
  const read = (): JavascriptBridge | null =>
    ((window as unknown as { WebViewJavascriptBridge?: JavascriptBridge }).WebViewJavascriptBridge ??
      null);

  const existing = read();
  if (existing) return existing;

  return new Promise((resolve) => {
    const timerId = window.setTimeout(() => resolve(read()), timeoutMs);
    document.addEventListener(
      'miaobi-jsbridge-ready',
      () => {
        window.clearTimeout(timerId);
        resolve(read());
      },
      { once: true },
    );
  });
}
